export const Id = {
    SolicitorCode:"SolicitorCode",
    NameOfLodgingParty:"NameOfLodgingParty",
    Date:"Date",
    HaveCheque:"HaveCheque",
    NoOfCheques:"NoOfCheques",
    TotalAmount:"TotalAmount",
    NatureOfInstrument:"NatureOfInstrument",
    PRN:"PRN",
    
    importedData:"importedData",
    presetSolicitorCode:"presetSolicitorCode",
    dupRec:"dupRec"
};

export const HaveCheque = {
    YES: "0",
    NO: "1"
}

export const LOCAL_EMEMO_DATA = "LOCAL_EMEMO_DATA"

export const STEPID = "steps_Particulars";
export const TITLE = "steps_Particulars";
export const part_a_particulars = "part_a_particulars";
export const additional_title = "additional_title";